import styled from '@emotion/styled';
import { ob } from '../onboardingV2.tokens';

export const Options = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 8px;
`;

export const TypeCard = styled.button`
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
    text-align: left;
    padding: 16px;
    border-radius: ${ob.radius.lg};
    background: ${(props) => (props.selected ? ob.color.lime50 : ob.color.surface)};
    border: 2px solid
        ${(props) => (props.selected ? ob.color.lime : ob.color.borderSubtle)};
    cursor: pointer;
    transition:
        border-color ${ob.motion.base} ${ob.motion.ease},
        background ${ob.motion.base} ${ob.motion.ease};

    &:hover {
        border-color: ${(props) => (props.selected ? ob.color.lime : ob.color.borderHover)};
    }

    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px ${ob.color.lime200};
    }
`;

export const IconCircle = styled.span`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: ${(props) => (props.selected ? ob.color.brand : ob.color.lime100)};
    color: ${(props) => (props.selected ? ob.color.surface : ob.color.brand)};
    font-size: 24px;
`;

export const CardText = styled.span`
    display: flex;
    flex-direction: column;
    min-width: 0;

    strong {
        font-family: ${ob.font.heading};
        font-size: 16px;
        font-weight: 700;
        color: ${ob.color.brand};
    }

    span {
        margin-top: 2px;
        font-size: 13px;
        line-height: 1.35;
        color: ${ob.color.body};
    }
`;

export const RadioDot = styled.span`
    flex-shrink: 0;
    margin-left: auto;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid ${(props) => (props.selected ? ob.color.lime : ob.color.border)};
    position: relative;

    &::after {
        content: '';
        position: absolute;
        inset: 3px;
        border-radius: 50%;
        background: ${(props) => (props.selected ? ob.color.lime : 'transparent')};
    }
`;
